import React from 'react';
import GIELink from "../../components/GIELink/GIELink";

export default class ResiliationHome extends React.Component<any, any> {
    render() {
        return (
            <div className="text-center">
                <span className="me-2">Vous souhaitez résilier votre contrat ?</span>
                <GIELink href="https://gie-sa.fr/services-en-ligne/je-resilie-mon-contrat/">Cliquez ici</GIELink>
            </div>
        );
    }
}
